import { render, staticRenderFns } from "./SaasPaymentsList.vue?vue&type=template&id=5c043ec4&"
import script from "./SaasPaymentsList.vue?vue&type=script&lang=js&"
export * from "./SaasPaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports